import Link from 'atomic/link';
import ProductListImpression from 'components/impressions/product-impression/list/product-list-impression';
import React from 'react';
import WidgetProductSliderProps from '../widget-product-slider.props';
import LinkedWrapper from 'atomic/linked-wrapper';
import Button from 'atomic/button';
import { CATALOG_IMAGE_HEIGHT, CATALOG_IMAGE_WIDTH } from 'helpers/constants';
import SrcSizes from 'modules/shared/components/src-sizes/src-sizes';
import ProductBoxPrice from 'modules/shared/components/product/components/product-box-price';
import { prepareOfferDataForDiscount } from 'modules/shared/helpers/prepare-offer-data-for-discount';

import './widget-product-slider.mobile.scss';

const WidgetProductSliderMobile: React.FC<WidgetProductSliderProps> = ({ config, data, isBot }) => {
    const { items } = data;

    return (
        <div className="w-product-slider-m">
            <div className="w-product-slider-m__list">
                {
                    items.map(product => {
                        const shouldTileRedirectToPartner = !isBot && product.redirectUrl;
                        const productUrl = !isBot && product.redirectUrl ? product.redirectUrl : product.url;
                        const {
                            discount,
                            price,
                            offersCount,
                            prevPrice,
                            productHasNoOffers
                        } = prepareOfferDataForDiscount(
                            product.minPrice,
                            product.prevPrice,
                            product.offers.items,
                            product.offers.count
                        );

                        return (
                            <LinkedWrapper
                                key={product.id}
                                className="w-product-slider-m__list__item-content"
                                title={product.offers?.items?.[0]?.dealer?.name || product.name}
                                href={productUrl}
                                target={shouldTileRedirectToPartner ? '_blank' : '_self'}
                                rel={shouldTileRedirectToPartner ? 'nofollow noopener noreferrer' : void 0}
                            >
                                <ProductListImpression
                                    trackedData={{ ...product, price }}
                                    className={'w-product-slider-m__list__item-content__image'}
                                >
                                    <SrcSizes
                                        image={product.photo}
                                        imageSizes={product.photoRetina
                                            ? [
                                                { image: product.photo, width: CATALOG_IMAGE_WIDTH },
                                                { image: product.photoRetina, width: CATALOG_IMAGE_WIDTH * 2 }
                                            ]
                                            : undefined}
                                        alt={product.name}
                                        lazyLoad={config?.lazyLoad}
                                        width={CATALOG_IMAGE_WIDTH}
                                        height={CATALOG_IMAGE_HEIGHT}
                                    />
                                </ProductListImpression>
                                <div className="w-product-slider-m__list__item-content__title">
                                    <h3>
                                        <Link
                                            className="w-product-slider-m__list__item-content__link"
                                            href={product.url}
                                            rel={productHasNoOffers ? 'nofollow' : void 0}
                                        >
                                            {product.name}
                                        </Link>
                                    </h3>
                                </div>
                                <div className="w-product-slider-m__list__item-content__price">
                                    <ProductBoxPrice
                                        price={price}
                                        prevPrice={prevPrice}
                                        offersCount={offersCount}
                                        discount={discount}
                                    />
                                </div>
                                <Button
                                    className="w-product-slider-m__list__item-content__button"
                                    color="primary"
                                    size="lg"
                                    tag="div"
                                >
                                    {shouldTileRedirectToPartner ? 'Idź do sklepu' : 'Zobacz produkt'}
                                </Button>
                            </LinkedWrapper>
                        );
                    })
                }
            </div>
        </div>
    );
};

export default WidgetProductSliderMobile;
